import * as React from 'react';
import { Sorting } from '@elastic/react-search-ui';
import { Config } from '../../helper';
import { OpenSearchDropdown, OpenSearchFacet, OpenSearchSearchBox, OpenSearchSelectFacet } from '../components';

const FACET_WIDGETS = {
  [Config.FacetWidgets.Multiselect]: OpenSearchDropdown,
  [Config.FacetWidgets.Dropdown]: OpenSearchSelectFacet,
};

export default function StandardLayoutFilters(props) {
  const {
    facets = [],
    sorting = [],
  } = props;

  const sortOptions = sorting.map(opt => {
    return {name: opt.label, value: opt.field, direction: opt.direction};
  });

  return (
    <div className='filters'>
      <div className='filters__header'>
        <p className='h--smaller filters__title d-flex align-items-center'>{Config.I18n.Filters.BlockLabel}</p>
      </div>

      <OpenSearchSearchBox/>

      {sortOptions && sortOptions.length > 1 && (
        <div className='block block--sorting'>
          <p className='h--smallest'>{Config.I18n.Filters.SortByLabel}</p>
          <Sorting sortOptions={sortOptions}/>
        </div>
      )}

      {facets.length > 0 && facets.map(facetConfig => {
        const {field, label, hidden = false, widget} = facetConfig;
        // Default (empty/unknown widget) renders inline checkboxes; see FACET_WIDGETS for the
        // dropdown variants.
        const FacetComponent = FACET_WIDGETS[widget] || OpenSearchFacet;

        return (
          <FacetComponent
            key={field}
            field={field}
            label={label}
            hidden={hidden}
            show={20}
          />
        );
      })}
    </div>
  );
}
